module.exports = __webpack_public_path__ + "static/img/公司1.d9df275.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/公司1.jpg
// module id = Xl2C
// module chunks = 1